export default __webpack_public_path__ + "static/media/remos.43a20a2b.png";